import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { getBanner, IBanner } from "../../../api/commonApi";
import { useTranslation, withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SmallLoading from "../loading/SmallLoading";
import { useRecoilValue } from "recoil";
import ReactGA4 from "react-ga4";
import { langCodeState } from "../../../recoil/commonUiAtom";

function LnbPromo() {
  const { data, isLoading } = useQuery<IBanner>("banner", getBanner);
  const [imgHover, setImgHover] = useState<string | undefined>("");
  const [bannerlang, setBannerlang] = useState("");
  const langCode = useRecoilValue(langCodeState);

  useEffect(() => {
    if (data?.result === 1) {
      setImgHover(data?.data[0].banner_image_url);
    }
  }, [data]);

  useEffect(() => {
    if (data?.result === 1) {
      setBannerlang(data.data[0].language);
    }
  }, [langCode]);

  const targetPage = (url: string) => {
    window.open(url, "_self");
    ReactGA4.gtag("event", "click", {
      event_category: "check_clicking",
      event_label: "Combine D6|Pmang(G・O・P運営)"
    });
  };

  const compareDate = (start: any, end: any) => {
    let startDate = new Date(start).getTime();
    let endDate = new Date(end).getTime();

    let todayDate = new Date().getTime();

    if (startDate <= todayDate && endDate > todayDate) {
      return true;
    }
    return false;
  };

  return isLoading ? (
    <SmallLoading customheight={"25rem"} />
  ) : data?.result === 1 ? (
    bannerlang === langCode ? (
      compareDate(data.data[0].start_date, data.data[0].end_date) ? (
        <div className="lnb-promo">
          <div key={data?.data[0].idx}>
            <div className="promo-side">
              <div className="title">
                {data.data[0].banner_name === "" ||
                data.data[0].banner_name === null
                  ? null
                  : data.data[0].banner_name}
              </div>
              <Link
                to="#"
                onClick={() => targetPage(`${data.data[0].target_url}`)}
                title={data.data[0].banner_name}
              >
                <img
                  src={imgHover}
                  alt={data?.data[0].banner_image_url}
                  onMouseEnter={() =>
                    setImgHover(data.data[0].banner_hover_image_url)
                  }
                  onMouseLeave={() =>
                    setImgHover(data?.data[0].banner_image_url)
                  }
                />
              </Link>
            </div>
          </div>
        </div>
      ) : null
    ) : null
  ) : null;
}
export default React.memo(withTranslation()(LnbPromo));
